import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import frFR from 'antd/locale/fr_FR';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

import App from './App';
import { store } from './store';
import './index.css';

// Configure dayjs
dayjs.locale('fr');

// Configure Ant Design theme
const theme = {
  token: {
    colorPrimary: '#004C92',
    colorSuccess: '#00AF00',
    colorWarning: '#FFB900',
    colorError: '#FF0000',
    borderRadius: 8,
    fontFamily: 'Inter, system-ui, sans-serif',
  },
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <BrowserRouter>
      <ConfigProvider locale={frFR} theme={theme}>
        <App />
      </ConfigProvider>
    </BrowserRouter>
  </Provider>
);
